import React, { useState } from 'react';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label?: string;
  error?: string;
  showPasswordToggle?: boolean;
}
export function Input({
  label,
  error,
  type = 'text',
  showPasswordToggle = false,
  className = '',
  id,
  ...props
}: InputProps) {
  const [showPassword, setShowPassword] = useState(false);
  const inputId = id || label?.toLowerCase().replace(/\s/g, '-');
  const inputType = showPasswordToggle && type === 'password' ? showPassword ? 'text' : 'password' : type;
  return <div className="w-full" data-id="element-1066">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-text-primary mb-1.5" data-id="element-1067">
          {label}
        </label>}
      <div className="relative" data-id="element-1068">
        <input id={inputId} type={inputType} className={`
            w-full px-3 py-2.5
            border border-border rounded-md
            text-text-primary text-sm
            placeholder:text-text-tertiary
            focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary
            transition-colors duration-150
            ${error ? 'border-urgent focus:ring-urgent focus:border-urgent' : ''}
            ${showPasswordToggle ? 'pr-10' : ''}
            ${className}
          `} {...props} data-id="element-1069" />
        {showPasswordToggle && type === 'password' && <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-text-tertiary hover:text-text-secondary transition-colors" aria-label={showPassword ? 'Hide password' : 'Show password'} data-id="element-1070">
            {showPassword ? <EyeOffIcon className="w-4 h-4" data-id="element-1071" /> : <EyeIcon className="w-4 h-4" data-id="element-1072" />}
          </button>}
      </div>
      {error && <p className="mt-1.5 text-xs text-urgent" data-id="element-1073">{error}</p>}
    </div>;
}